import { z } from 'zod';

/**
 * Forgot password form validation schema.
 * Matches RA2: clinic_number + login_id.
 */
export const forgotPasswordFormSchema = z.object({
  clinic_number: z.string().trim().min(1, '治療院IDは必須です'),
  login_id: z.string().trim().min(1, 'ユーザーIDは必須です'),
});

export type ForgotPasswordFormData = z.infer<typeof forgotPasswordFormSchema>;
